import { render, staticRenderFns } from "./RepresentativeExample.vue?vue&type=template&id=efdb98b2"
import script from "./RepresentativeExample.vue?vue&type=script&lang=js"
export * from "./RepresentativeExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports